import { useEffect, useState } from 'react';
import { getStorePricing } from '../api';

// The free Store allowance, read from the API instead of typed into copy.
//
// Three Send screens said "5 GB free" while the backend's freeGbFor() was the
// only real source — and Jordan's 10/28 decision moved everyone to one number.
// Reading it here means the next change needs no front-end deploy. Until the
// call answers (or if it fails) the copy says "free to start", which is true
// at any allowance.
//
// Module-level cache: Dashboard and Recipient both mount this; one request
// per page load is plenty for a value that changes once a quarter.
let cached = null;
let inflight = null;

export function useStoreFreeGb() {
  const [gb, setGb] = useState(cached);
  useEffect(() => {
    if (cached != null) { setGb(cached); return undefined; }
    let alive = true;
    inflight = inflight || getStorePricing()
      .then((r) => {
        const n = Number(r?.free_gb?.personal);
        cached = Number.isFinite(n) && n > 0 ? n : null;
        return cached;
      })
      .catch(() => null)
      .finally(() => { inflight = null; });
    inflight.then((v) => { if (alive) setGb(v); });
    return () => { alive = false; };
  }, []);
  return gb;
}

/** "10 GB free" when known, "free to start" while loading or if the call failed. */
export function freeGbCopy(gb, { suffix = 'free' } = {}) {
  return gb ? `${gb} GB ${suffix}` : 'free to start';
}
